
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepEmploymentRevisionForm.html?raw';
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { StringHelpers, ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import on from 'dojo/on';
import { PEP, PepClassnames } from "../PepTypes";


class PepEmploymentRevisionForm extends compose(_uiFrameMixin, _StatefulSection) {
    templateString: any = template;

    private inputEvTaskStart: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEvTaskEnd: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEvTaskEndActual: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEvTaskStartActual: MdsLax<InstanceType<typeof DateTimeInput>>;

    //private btnSave: Button;

    private entityID: string = null;
    //private entityData: PEP.EmploymentRevisionEntity;
    private entityViewLoaded: boolean = false;
    private entityView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private entityViewContainer: HTMLElement;

    private breaksReg: Record<number, { containerNode: HTMLElement, inputStart: HTMLInputElement, inputEnd: HTMLInputElement, propnameStart: string, propnameEnd: string }>
    private multiBreaksSection: HTMLElement;

    private txtReadonlyMessage: HTMLElement;

    //private _pepEditor: PepEmploymentEditor;
    //private editorContainer: HTMLElement;

    setup(employmentID: string) {
        this.entityID = employmentID;

        this.loadData();
    }

    loadData() {
        if (this.entityID) {
            this.setStartupState("loading");
            this.entityView.setup(this.entityID, PepClassnames.vt_empl_A, null, "gDisp_1", this.entityViewContainer, null, "PepEmploymentRevision");
        } else {
            this.setStartupState("ready");
        }
    }

    private _onLoadedView(data: PEP.EmploymentRevisionEntity) {
        this.entityViewLoaded = true;
        this.hideNode(this.entityViewContainer, false);
        
        if (data) {
            this.setReadonly(data._readonly !== false);
            this.entityView.setNonInteractive(data._readonly);

            this._drawBreaks(data);
            this.setData(data);

        } else {
            this.setReadonly(true);
        }
    }

    protected onDirtyChange(state?) {
        //this.btnSave.setReadonly(this.isDirty() != true);
        this.enableButton("submit", this.isDirty() == true && this.isReadonly() != true);
    }

    afterSetData() {
        let data = this.sourceData as PEP.EmploymentRevisionEntity;


        //this.disableNode(this.domNode, data.ref_address_1.ID != this.getCurrentEmployeeId());
        
        if (data._readonlyMessage) {
            this.txtReadonlyMessage.innerHTML = data._readonlyMessage;
        }

        this.hideNode(this.txtReadonlyMessage, !data._readonlyMessage);

        if (!this.isReadonly()) {
            this.addButtonEx({
                internalName: "submit",
                label: "General_Submit",
                callback: lang.hitch(this, this._onClick_Save),
                position: "primary",
                styleClass: "primary",
                iconClass: "fas fa-check"
            });

            //this.btnSave.setReadonly(true);
            this.disableButton("submit");
        }
    }

    //private _onEditor(data1, data2) {
    //    debugger;
    //    alert("editor");
    //}

    private _drawBreaks(data: PEP.EmploymentRevisionEntity) {
        //let data = this.sourceData as PEP.EmploymentEntity;
        this.hideNode(this.multiBreaksSection);
        this.UiModder.domConstruct.empty(this.multiBreaksSection);
        this.breaksReg = {};

        let create = this.UiModder.domConstruct.create;
        let count: number = 3;
        if (count > 0) {
            this.hideNode(this.multiBreaksSection, false);

            for (let breakNo = 1; breakNo <= count; breakNo++) {
                let propNameStart = StringHelpers.stringFormat("time_break_{0}_start", breakNo.toString());
                let propNameEnd = StringHelpers.stringFormat("time_break_{0}_end", breakNo.toString());
                let startTXT = data[propNameStart];
                let endTXT = data[propNameEnd];

                let breakContainer = create("div", {
                    className: "break editorSection"
                }, this.multiBreaksSection);

                let head = create("h6", {
                    innerHTML: StringHelpers.stringFormat(TranslationHelpers.translate("PEP_EmploymentEditor__LblBreakNo"), breakNo.toString())
                }, breakContainer);

                
                let row = create("div", {
                    className: "flex_row_center flex_gap"
                }, breakContainer);

                let startContainer = create("div", {
                    className: "flex_row_center flex_gapSmall"
                }, row);

                let label = create("label", {
                    innerHTML: TranslationHelpers.translate("PEP_EmploymentEditor__LblBreakFrom"),
                }, startContainer);

                let startInput = create("input", {
                    type: "time",
                    value: startTXT,
                    //"data-key": propNameStart,
                }, startContainer) as HTMLInputElement;

                let endContainer = create("div", {
                    className: "flex_row_center flex_gapSmall"
                }, row);

                let labelEnd = create("label", {
                    innerHTML: TranslationHelpers.translate("PEP_EmploymentEditor__LblBreakTo"),
                }, endContainer);

                let endInput = create("input", {
                    type: "time",
                    value: endTXT,
                    //"data-key": propNameEnd,
                }, endContainer) as HTMLInputElement;

                

                this.breaksReg[breakNo] = {
                    containerNode: breakContainer,
                    inputStart: startInput,
                    inputEnd: endInput,
                    propnameEnd: propNameEnd,
                    propnameStart: propNameStart
                }

                if (data._canEditBreaks != true || this.isReadonly()) {
                    this.disableNode(startInput);
                    this.disableNode(endInput);
                } else {
                    on(startInput, "change", lang.hitch(this, this._onChangeBreak, breakNo));
                    on(endInput, "change", lang.hitch(this, this._onChangeBreak, breakNo));
                }
            }
        }

    }

    private _onChangeBreak(breakNo: number) {
        let brk = this.breaksReg[breakNo];

        this.setAttributeValue(brk.propnameStart, brk.inputStart.value, true);
        this.setAttributeValue(brk.propnameEnd, brk.inputEnd.value, true);
    }

    private _onClick_Save(evt: MouseEvent) {
        if (this.isDirty(true)) {
            this.saveChanges();
        }
    }


    private saveChanges() {
        
        this.StandbyStart();
        this.emit("saving");

        //this.btnSave.setReadonly(true);
        this.disableButton("submit");

        let data = {
            employmentID: this.entityID,
            changedData: this.getChangedData()
        };


        this.RequestManager.callfunction(
            "Webtool_API_PEP_EmploymentAgenda__SaveEditorData",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError),
            false
        );
    }

    private _onSaveDataResponse(response: more.simpleJsonResponse) {
        this.StandbyStop();

        // anm: Warnungen kommen per simpleResponse auch im Successfall. Dann sollte aber nicht gespeichert werden.
        let bIsSuccess = true;

        if (typeof (response) == "object" && !!response) {
            if (response.success === false) {
                bIsSuccess = false;
                if (response.message) {
                    
                }

                ToasterHelpers.showToast({
                    title: "PEP_EmploymentRevision__SaveResultWarning",
                    message: response.message,
                    iconClass: toasterIcons.warning,
                    ID: this.id + "_warning",
                    timeout: "permanent"
                });

            } else {
                ToasterHelpers.removeToast(this.id + "_warning");

            }
        }
        
        if (response.success !== false) {
            ToasterHelpers.showToast({
                title: "General__SaveSuccess",
                message: response.message,
                iconClass: ToasterHelpers.ToasterIcons.confirmCheck
            });
        }

        if (bIsSuccess == true) {
            this.emit("saved", true);

            this.resetDirty();

            this.loadData();
        } else {
            this.onDirtyChange();
        }
    }

    private _onSaveDataError(error: more.requestErrorMessage) {
        this.StandbyStop();

        //this.btnSave.setReadonly(false);
        this.enableButton("submit");

        ToasterHelpers.showToast({
            title: "General__ProcessFailed",
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });

        this.emit("saved", false);
    }

    private _onChange_ActualTimes() {
        
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PepEmploymentRevisionForm);